<template>
    <div class="px-0">
        <v-container fluid class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1" >
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('advanced_fulfillment_pendings.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <btn-primary :label="'advanced_fulfillment_pendings.prepare'" @click="prepareOrders" :loading="loadPrepare" :icon="'send_and_archive'" v-permission="shipping_service + '_advanced_fulfillment.process'" ></btn-primary>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :pagination="[15, 25, 100, 200]" show-select @input:selected="handleSelected($event)" v-model="selected" :props="{headers:headers, items: props.items, search:props.search}" :itemsLength="props.meta.total" :options.sync="pagination" @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>     
            <v-dialog v-model="modalDelete" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h3 class="text-uppercase">
                                {{ $t('advanced_fulfillment_pendings.modal.delete') }}
                            </h3>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-3 my-3 text-center">
                            <v-col cols="12">
                                <h5>{{ $t('advanced_fulfillment_pendings.modal.message') }}</h5>
                            </v-col>
                        </v-row>
                        
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalDelete = false">{{ $t('advanced_fulfillment_pendings.no') }}</v-btn>
                            <v-btn color="error" @click="deleteOrder">
                                {{ $t('advanced_fulfillment_pendings.yes') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalDetail" persistent max-width="90%" v-if="orderToShow != null">
                <v-card style="min-width: 700px !important">
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h4 class="text-uppercase blue_accent--text py-2">
                                {{ $t('fulfillments_cod_pendings.order_details.header') }} {{ this.orderToShow.uniqueOrderNumber }}
                            </h4>
                        </v-row>
                    </v-card-title>
                    
                    <div class="marker1-1" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillments_cod_pendings.details') }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.order_number") }}</label> <label>{{ this.orderToShow.uniqueOrderNumber }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.date") }}</label> <label>{{ this.orderToShow.createdAt }}</label></div>
                    <div class="detail_content1" v-if="shipping_service != 'otra'"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.shipping_service") }}</label> <label>{{ this.orderToShow.shippingService }}</label></div>
                    <div class="detail_content1" v-if="shipping_service == 'otra'"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.shipping_service") }}</label> <label>{{ this.orderToShow.externalShippingService }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.invoice") }}</label> <label>{{ this.orderToShow.invoice }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.client != null"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.client") }}</label> <label>{{ this.orderToShow.client.name }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.cod") }}</label> <label>{{ this.orderToShow.total }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.buyer") }}</label> <label>{{ this.orderToShow.consignee.name }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.state") }}</label> <label>{{ this.orderToShow.consignee.state }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.municipality") }}</label> <label>{{ this.orderToShow.consignee.municipality }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.neighborhood") }}</label> <label>{{ this.orderToShow.consignee.neighborhood }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.address") }}</label> <label>{{ this.orderToShow.consignee.street }} {{ this.orderToShow.consignee.externalNumber }} {{ this.orderToShow.consignee.internalNumber }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.zip_code") }}</label> <label>{{ this.orderToShow.consignee.zipcode }}</label></div>
                    
                    <div class="marker1-1 mt-2" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillments_cod_pendings.products') }}</label></div>
                    <span v-if="orderToShow.shipmentProductDetail != null">
                        <div v-for="(product, i) of orderToShow.shipmentProductDetail.data" :key="i" class="detail_content1"><label style="font-weight:bold">{{ product.attributes.product.sku }}</label> <label>{{ product.attributes.quantity }}</label></div>
                    </span>
                    <span v-if="orderToShow.products != null">
                        <div v-for="(product, i) of orderToShow.products" :key="i" class="detail_content1"><label style="font-weight:bold">{{ product.sku }}</label> <label>{{ product.quantity }}</label></div>
                    </span>

                    <v-card-text class="mt-5">
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalDetail = false">{{ $t('fulfillments_cod_pendings.go_back') }}</v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalAlreadyOpen" persistent max-width="50%">
                <v-card>
                    <v-row align="center" justify="center" class="text-center py-8 px-10">
                        <v-col cols="12">
                            <h3>{{ $t('fulfillments_cod_pendings.multiple_fulfillment_tabs') }}</h3>
                        </v-col>
                    </v-row>
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalAlreadyWithSession" persistent max-width="50%">
                <v-card>
                    <v-row align="center" justify="center" class="text-center py-8 px-10 mx-0">
                        <v-col cols="12">
                            <h3>{{ $t('advanced_fulfillment_pendings.previous_session') }}</h3>
                        </v-col>
                    </v-row>
                    
                    <v-row align="end" justify="end" class="text-center py-8 px-10 mx-0">
                        <btn-sf :label="'advanced_fulfillment_pendings.no'" class="mr-3" style="border-color: red; color: red !important;" @click="cancelCurrentSession()"></btn-sf>
                        <btn-pf :label="'advanced_fulfillment_pendings.continue'" @click="continueSession()"></btn-pf>
                    </v-row>
                    
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
            </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import { HttpShipmentsInProcessRepository } from '../../../shipment_in_process/infrastructure/repositories/shipment_in_process_repository';
import { HttpShipmentRepository } from '../../infrastructure/shipment_repository';
import { releaseShipmentsInProcessUseCase } from '../../../shipment_in_process/application/use_cases/release_shipments_in_process_use_case';
import { affShipmentsIndexUseCase } from '../../application/use_cases/aff_shipments_index_use_case';

export default {
    computed: {
        headers(){            
            return [
                { text: this.$t('advanced_fulfillment_pendings.order'), align: "center", value: 'unique_order_number', class: 'text-uppercase' },
                { text: this.$t('advanced_fulfillment_pendings.customer'), align: "center", value: 'client.name', class: 'text-uppercase' },
                { text: this.$t('advanced_fulfillment_pendings.date'), align: "center", value: 'date', class: 'text-uppercase' },
                // { text: this.$t('advanced_fulfillment_pendings.value'), align: "center", value: 'total', class: 'text-uppercase' },
                { text: this.$t('advanced_fulfillment_pendings.actions'), align: "center", value: 'actions', class: 'text-uppercase', sortable: false},
            ];
        }
    },
    data(){
        return {
            shipping_service: this.$route.params.shipping_service,
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            modalDelete: false,
            modalDetail: false,
            modalAlreadyOpen: false,
            modalAlreadyWithSession: false,
            recordsToRelease: [],
            orderToDelete: "",
            selected: [],
            orderToShow: '',
            loadPrepare: false,
            props: {
                search: '',
                items: [],
                meta: {
                    total: 0,
                    total_pages: 0,
                    per_page: 15,
                    page: 1
                },
                sort_by: [],
            },
            pagination: { page: 1, itemsPerPage: 15, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false },
            debounceTimer: null,
        }
    },
    async mounted(){
        this.$store.state.module = "headers.advanced_fulfillment_" + this.shipping_service + "_pendings";
        await this.checkIfCanOpen(this.shipping_service);        
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            this.props.items = [];
            
            try {
                const response = await affShipmentsIndexUseCase("pending_orders", this.props.meta.page, this.props.meta.per_page, this.props.search, this.props.sort_by, this.shipping_service, HttpShipmentRepository);

                this.props.items = response.data.data;
                this.props.meta = response.data.meta;
            }
            catch(e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data
                }
            }
        },
        askDelete(order){
            this.modalDelete = true;
            this.orderToDelete = order;
        },
        showDetails(order){
            this.orderToShow = order;
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
 
            this.$http.get(this.$store.state.chronosApi + 'shipment/getOrderInformation/' + order, {headers: {Authorization: lsToken}})
            .then((response) => {
                response.data = response.data.data.attributes;
                this.$store.state.loaderProps.visible = false;
                this.orderToShow = response.data;
                this.modalDetail = true;
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        prepareOrders(){
            if(this.selected.length > 0) { 
                localStorage.setItem('afpendings', JSON.stringify(this.selected.map(order => order.id)));
                
                this.loadPrepare = true;
                this.$router.push({ name: 'AFPrepare' });   
            }
            else {
                this.snackbar = {
                    visible: true,
                    color: 'warning',
                    text: this.$t('advanced_fulfillment_pendings.select_orders_before')
                }
            }
        },
        prepareSingleOrder(order){ 
            this.loadPrepare = true;
            localStorage.setItem('afpendings', JSON.stringify([order]));

            this.$router.push({ name: 'AFPrepare' });   
        },
        deleteOrder(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");

            this.$http.delete(this.$store.state.chronosApi + 'shipment/deleteOrder/' + this.orderToDelete, {headers: {Authorization: lsToken}})
            .then((response) => {
                if(response.data.success == true){
                    this.snackbar = {
                        visible: true,
                        color: 'success2',
                        text: this.$t('fulfillments_prepaid_pendings.deleted')
                    }
                    this.modalDelete = false;
                    this.index();
                }
                else{
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: this.$t('fulfillments_prepaid_pendings.deleted_failed')
                    }
                    this.modalDelete = false;
                    this.index();
                }
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        async handleSelected(value){
            this.selected = value;
        },
        async onOptionsChange(options) {
            this.props.meta.page = options.page;
            this.props.meta.per_page = options.itemsPerPage;
            
            if(options.sortBy.length > 0){
                this.props.meta.page = 1;
                this.props.sort_by = [{field: options.sortBy[0], direction: options.sortDesc[0] ? 'desc' : 'asc'}];
            } 
            else if(options.sortBy.length != this.props.sort_by.length) {
                this.props.meta.page = 1;
                this.props.sort_by = [];
            } 
            
            this.index();
        },
        checkIfCanOpen(parcel){
            localStorage.open_pages = Date.now();
            window.addEventListener('storage', (e) => {
                if(e.key == "open_pages") localStorage.setItem("a_fulfillment_" + parcel, Date.now())
                if(e.key == "a_fulfillment_" + parcel) this.modalAlreadyOpen = true;              
            }, false);
        },
        async checkIfAlreadyExistsASession() {
            const t_id = localStorage.getItem('trace_id');

            if(t_id != null && t_id != undefined) this.modalAlreadyWithSession = true;
        },
        async cancelCurrentSession() {
            this.modalAlreadyWithSession = false;

            const t_id = localStorage.getItem('trace_id');

            try {
                await releaseShipmentsInProcessUseCase(HttpShipmentsInProcessRepository, t_id);
                
                localStorage.removeItem('afpendings');
                localStorage.removeItem('trace_id');
            }
            catch(e) {
                console.log(e);
                
                this.snackbar = {
                    visible: true,
                    color: 'success2',
                    text: e.data.message
                }
            }

            this.index();
        },
        async continueSession() {
            this.$router.push({ name: 'AFPrepare' });   
        }
    },
    watch:{
        '$route.params.shipping_service': function() {
            location.reload();
        },
        'props.search': function() {
            clearTimeout(this.debounceTimer)
            
            this.debounceTimer = setTimeout(() => {
                this.props.meta.page = 1;
                this.index();
            }, 800);
        }
    }
}
</script>

<style>

</style>